module.exports = __webpack_public_path__ + "img/7.51b4b77e.png";